import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { RepoBusiness } from '../../models/repo-business/repo-business.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';

@Component({
  selector: 'app-repo-business-popup',
  templateUrl: './repo-business-popup.component.html',
  styleUrls: ['./repo-business-popup.component.scss'],
})
export class RepoBusinessPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  repoBusinessForm: FormGroup;
  error$ = this.repoBusinessFacade.error$;
  success$ = this.repoBusinessFacade.success$;
  loading$ = this.repoBusinessFacade.loading$;
  public isLoader: boolean = false;
  @Input() public isUSA: boolean = false;

  public countries: any[] = [];
  @Input() public data: any;
  constructor(
    public readonly modal: NgbActiveModal,
    private readonly repoBusinessFacade: RepoBusinessFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly toastService: ToastService,
    private readonly commonService: CommonService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.attachEvents();
    this.repoBusinessForm = RepoBusiness.asFormGroup(this.data);
    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.countries = responseData;

          if (this.countries && this.countries?.length > 0) {
          }
        }
      }
    });
  }
  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
  public submitForm(formData: any): void {
    if (this.repoBusinessForm.invalid) {
      for (var i in this.repoBusinessForm.controls) {
        this.repoBusinessForm.controls[i].markAsTouched();
      }
      return;
    }
    let repoBusiness = formData as RepoBusiness;
    repoBusiness.repoBusinessId = this.data?.repoBusinessId;
    repoBusiness.postCode = repoBusiness?.postCode?.toString();
    this.repoBusinessFacade.saveRepoBusiness(repoBusiness);
  }
  public attachEvents(): void {
    this.loading$.pipe(takeUntil(this.unsubscribe$)).subscribe((loading) => {
      this.isLoader = loading;
    });
    this.success$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response?.saveRepoBusiness) {
        if (this.isUSA) {
          this.toastService.success('Organization Saved', 'Success!');
        } else {
          this.toastService.success('Organisation Saved', 'Success!');
        }
        this.repoBusinessFacade.loadRepoBusinesses();
        this.closePopup();
      }
    });
    this.error$.pipe(takeUntil(this.unsubscribe$)).subscribe((err) => {
      if (err) {
        this.httpErrorHandlerService.ShowErrorMessage(err);
      }
    });
  }
}
